import { render, staticRenderFns } from "./PaymentDelivery.vue?vue&type=template&id=8808bffe&scoped=true"
import script from "./PaymentDelivery.vue?vue&type=script&lang=ts"
export * from "./PaymentDelivery.vue?vue&type=script&lang=ts"
import style0 from "./PaymentDelivery.vue?vue&type=style&index=0&id=8808bffe&prod&lang=scss&scoped=true"
import style1 from "./PaymentDelivery.vue?vue&type=style&index=1&id=8808bffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808bffe",
  null
  
)

export default component.exports